import { BidItemInterface, TaskCodeInterface } from "../interfaces/Interfaces";

export const bidItemDictionary: BidItemInterface = {
  "BidItem": "Bid Item",
  "BidItemDisplay": "Bid Item",
  "ChgOrderDesc": "Chg. Order Desc.",
  "DisplayNumber": "CCO Sort",
  "BidItemDescription": "Description",
  "UM": "UOM",
  "QTYBilled": "Bid QTY",
  "UnitPrice": "Bid UP",
  "Amount": "Bid Tot'l",
  "FinalQuantity": "Fin'l QTY",
  "FinalRevenue": "Fin'l Rev",
  "HasEditedFields": "N/A",
  "MTDCost": "MTD Cost",
  "QtyAdjustment": "QTY Adj.",
  "JTDQty": "JTD Qty",
  "JTDCost": "JTD Cost",
  "RemCost" : "Rem Cost",
  "FinalCost": "Fin'l Cost",
  "PreviousFinalCost": "Prev Final Cost",
  "Changes": "Delta",
  "GainLoss": "G/L",
  "BidComments" : "Comments"
};

export const bidItemDetailsDictionary: BidItemInterface = {
  "BidItem": "Bid Item",
  "BidItemDisplay": "Bid Item",
  "ChgOrderDesc": "Chg. Order Desc.",
  "DisplayNumber": "CCO Sort",
  "BidItemDescription": "Description",
  "UM": "UOM",
  "QTYBilled": "Bid QTY",
  "UnitPrice": "Bid UP",
  "Amount": "Bid Tot'l",
  "QtyAdjustment": "QTY Adj.",
  "JTDQty": "JTD Qty",
  "FinalQuantity": "Fin'l QTY",
  "FinalRevenue": "Fin'l Rev",
  "FinalCost": "Fin'l Cost",
  "RemCost" : "Rem Cost",
  "GainLoss": "G/L",
  "PreviousFinalCost": "Prev Final Cost",
  "Changes": "Delta",
  "BidComments" : "Comments",
  "HasEditedFields": "N/A"
};

export const bidItemDictionaryDefault: BidItemInterface = {
  "BidItem": "Bid Item",
  "BidItemDisplay": "Bid Item",
  "ChgOrderDesc": "Chg. Order Desc.",
  "DisplayNumber": "CCO Sort",
  "BidItemDescription": "Description",
  "UM": "UOM",
  "QTYBilled": "Bid QTY",
  "Amount": "Bid Tot'l",
  "FinalQuantity": "Fin'l QTY",
  "FinalRevenue": "Fin'l Rev",
  "HasEditedFields": "N/A",
  "MTDCost": "MTD Cost",
  "JTDCost": "JTD Cost",
  "RemCost" : "Rem Cost",
  "FinalCost": "Fin'l Cost",
  "PreviousFinalCost": "Prev Final Cost",
  "Changes": "Delta",
  "BidComments" : "Comments"
};

export const taskCodeDictionary: TaskCodeInterface = {
  "Taskcode": "Task Code",
  "TaskcodeDescription": "Description",
  "UnitOfMeasure": "UOM",
  "BudgetUnits": "Budj. QTY",
  "BudgetUnitCost": "Budj. UC",
  "BudgetTotalCost": "Budj. Tot'l",
  "MTDCost": "MTDCost",
  "JTDUnits": "JTD Units",
  "JTDUnitCost": "JTD UC",
  "JTDTotalCost": "JTD Cost",
  "RemainingUnits": "Rem Units",
  "RemainingUnitCost": "Rem UC",
  "RemainingTotalCost": "Rem Cost",
  "FinalQuantity": "Fin'l QTY",
  "FinalUnitCost": "Fin'l UC",
  "FinalCost": "Fin'l Cost",
  "QtyAdjustment": "QTY Adj.",
  "RecoveryPercent": "Recovery Percent",
  "CostGL": "Cost G/L",
  "Changes": "Delta",
  "LastMonthFinalCost": "Prev Fin'l Cost",
  "Comments": "Comments",
  "CCOs": [],
  "HasEditedFields": "Edd",
};